// Ícone SVG inline da bandeira Cabal (sem requisição HTTP)
import * as React from 'react';

export function CabalIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 48 32" role="img" aria-label="Cabal" {...props}>
      <rect width="48" height="32" rx="4" fill="#fff" stroke="#E5E7EB" />
      <text
        x="24"
        y="17"
        textAnchor="middle"
        fontFamily="Arial, Helvetica, sans-serif"
        fontWeight="800"
        fontSize="8"
        fill="#EE2E24"
      >
        cabal
      </text>
      <rect x="10" y="20" width="9" height="2" fill="#EE2E24" />
      <rect x="20" y="20" width="9" height="2" fill="#00A859" />
      <rect x="30" y="20" width="8" height="2" fill="#0072BC" />
    </svg>
  );
}
